import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Tour } from '../../api/models';

export type TABLE_TYPE = Table<Tour>;

export const TABLE = 'tour';
const SCHEMA = 'tourId, sortId';

class TourDatabase implements DataRepository<Tour> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<Tour | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Tour, key: Key): Promise<Tour> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: Tour[]): Promise<Tour[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Tour[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const TourDB = new TourDatabase(db);
